import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Star as StarIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const Testimonials: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          component="h2"
          align="center"
          sx={{ fontWeight: 700, mb: 1, color: 'text.primary' }}
        >
          {t('testimonials.title')}
        </Typography>
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          sx={{ mb: 5 }}
        >
          {t('testimonials.subtitle')}
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            component="a"
            href="https://g.page/r/CZPxTTsqQ8l6EBM/review"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              bgcolor: 'white',
              borderRadius: 8,
              px: 3,
              py: 1.5,
              textDecoration: 'none',
              border: '1px solid',
              borderColor: 'rgba(0,0,0,0.1)',
              boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              '&:hover': {
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                transform: 'translateY(-2px)',
              },
            }}
          >
            <Box
              component="img"
              src="https://www.google.com/favicon.ico"
              alt="Google"
              sx={{ width: 22, height: 22 }}
            />
            <Box sx={{ display: 'flex', gap: 0.3 }}>
              {[1, 2, 3, 4, 5].map((s) => (
                <StarIcon key={s} sx={{ fontSize: 20, color: '#FBBC04' }} />
              ))}
            </Box>
            <Typography variant="body1" fontWeight={600} sx={{ color: '#1a1a1a', whiteSpace: 'nowrap' }}>
              See all our Google reviews
            </Typography>
            <ChevronRightIcon sx={{ fontSize: 20, color: '#666' }} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Testimonials;
